import { render, staticRenderFns } from "./twoOneModule.vue?vue&type=template&id=5cc1d4b1&scoped=true"
import script from "./twoOneModule.vue?vue&type=script&lang=js"
export * from "./twoOneModule.vue?vue&type=script&lang=js"
import style0 from "./twoOneModule.vue?vue&type=style&index=0&id=5cc1d4b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc1d4b1",
  null
  
)

export default component.exports